import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, Input, model, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { FloatLabelModule } from 'primeng/floatlabel';


@Component({
  selector: 'app-dropdown',
  standalone: true,
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
  imports: [CommonModule, FormsModule, MultiSelectModule, DropdownModule, SelectModule, FloatLabelModule],
})
export class DropdownComponent {
  showPanel = false;
  option = model<any>();
  @Input() options: any[] = [];
  @Input() propiedad!: string;
  @Input() filtrar!: boolean;
  @Input() limpiar!: boolean;
  @Input() etiqueta = 'Inserte etiqueta';
  @Input() placeholder = 'Inserte placeholder';
  @Input() id = '';
  @Input() descripcionLabel!: string | null;
  @Input() setFirstValue = true;
  @Input() readonly = false;
  @Input() disabled!: boolean;

  @ViewChild('dropdown') dropdown!: Dropdown;

  get sortedOptions(): any[] {
    return (this.options ?? []).slice().sort((a, b) =>
      this.optionText(a).localeCompare(this.optionText(b), 'es', {
        sensitivity: 'base',
        numeric: true,
      }),
    );
  }

  ngAfterViewInit() {
    if (this.setFirstValue) this.option.set(this.sortedOptions[0]);
  }

  private optionText(item: any): string {
    if (item == null) return '';
    if (this.propiedad && item?.[this.propiedad] != null) {
      return String(item[this.propiedad]).trim();
    }
    if (typeof item !== 'object') return String(item).trim();
    return String(item.label ?? item.nombre ?? item.descripcion ?? item.name ?? '').trim();
  }

  @Input() multiple = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
   * ingresa el valor */
  @Input() showError = false;
  @Input() mensajeError = '';
}
